import { AloftPrice, isDefined } from '@aloft/toolkit-shared';

export const getCostString = (cost: AloftPrice | undefined | null): string | null => {
  const rawCostString = cost?.toString(true);
  return isDefined(rawCostString) ? `= ${rawCostString}` : null;
};
